import {
  actionCreator, API_URL,
  checkHttpStatus, create_post_data, createRequestActionTypes, createSearchUrlForCustomAPI, createSearchUrlWithoutPageNumberAndSize, jsonApiHeader,
  showErrorMessage, showSuccessMessage, showWarningMessage,
} from './../../../../../actions/utilAction';

export { jsonApiHeader, showWarningMessage, showErrorMessage, actionCreator, checkHttpStatus, create_post_data, createSearchUrlForCustomAPI, createSearchUrlWithoutPageNumberAndSize, showSuccessMessage };

export const GET_MASTERDATABYNAME = `${API_URL}/api/MasterData/MasterDataByName`;
export const GET_PATIENT_PAYERS_API = `${API_URL}/GetPayerByPatient`;
export const GET_LEDGER_DETAILS_API = `${API_URL}/Claim/GetClaimsForLedger`;
export const GET_CLAIM_SERVICELINE_DETAILS_API = `${API_URL}/Claim/GetClaimServiceLinesForPatientLedger`;
export const GET_PAYMENT_DETAILS_API = `${API_URL}/api/Payment/GetPaymentDetailsById`;
export const POST_PAYMENT_DETAILS_API = `${API_URL}/api/Payment/SaveServiceLinePayment`;
export const GET_PATIENT_GUARANTOR_API = `${API_URL}/patients/GetPatientGuarantor`;
export const GET_PATIENT = `${API_URL}/api/PatientAppointments/GetStaffAndPatientByLocation`;
export const GET_MASTERTAGS = `${API_URL}/master-tags`;
export const DELETE_CLIENT_PAYMENT_API = `${API_URL}/api/Payment/DeleteServiceLinePayment`;
export const UPDATE_CLIENT_PAYMENT_STATUS_API = `${API_URL}/Claim/UpdatePaymentStatus`;
export const UPDATE_BATCH_CLAIMS_PAYMENT_STATUS = `${API_URL}/Claim/UpdateBatchClaimsPaymentStatus`;
export const UPDATE_BATCH_CLAIMS_OFFICEALLY_STATUS = `${API_URL}/Claim/UpdateBatchClaimsOfficeallyStatus`;

export const ledgerActionTypes = {
  get_master_data: createRequestActionTypes('GET_LEDGER_MASTER_DATA'),
  get_patientPayers: createRequestActionTypes('GET_PATIENT_PAYERS_FOR_LEDGER'),
  get_ledgerDetails: createRequestActionTypes('GET_LEDGER_DETAILS'),
  get_ledgerClaimServiceDetails: createRequestActionTypes('GET_CLAIM_SERVICELINE_DETAILS'),
  post_paymentDetails: createRequestActionTypes('POST_PAYMENT_DETAILS'),
  get_paymentDetails: createRequestActionTypes('GET_PAYMENT_DETAILS'),
  get_patientGuarantors: createRequestActionTypes('GET_PATIENT_GUARANTORS'),
  get_patient: createRequestActionTypes('GET_PATIENT'),
  get_patient_master_tags_ForLedger: createRequestActionTypes('GET_PATIENT_MASTER_TAGS_FORLEDGER'),
  delete_serviceLine_payment: createRequestActionTypes('DELETE_CLIENT_PAYMENT_API'),  
  update_clientPaymentStatus: createRequestActionTypes('UPDATE_CLIENTPAYMENTSTATUS'),
  update_batch_claims_payment_status: createRequestActionTypes('UPDATE_BATCH_CLAIMS_PAYMENT_STATUS'),
  update_batch_claims_officeally_status: createRequestActionTypes('UPDATE_BATCH_CLAIMS_OFFICEALLY_STATUS')
};



// WEBPACK FOOTER //
// ./src/modules/Billing/components/Ledger/constants/ApiConstants.js